import { useState } from "react";
import { createPortal } from "react-dom";
import { Share, SquarePlus, X } from "lucide-react";
import { Button } from "./ui/button";

const TXT = {
  en: { title: "Add {name} to your Home Screen", s1: "Tap the Share button", s2: "Choose 'Add to Home Screen'", sub: "Open your bookings and forms in one tap, like an app.", ok: "Got it" },
  it: { title: "Aggiungi {name} alla schermata Home", s1: "Tocca il pulsante Condividi", s2: "Scegli 'Aggiungi alla schermata Home'", sub: "Apri prenotazioni e moduli con un tocco, come un'app.", ok: "Ho capito" },
};

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const installed = () => window.navigator.standalone === true || window.matchMedia?.("(display-mode: standalone)").matches;

export function IosInstallTip({ slug, name, lang }) {
  const key = `bw_ios_tip_${slug}`;
  const [show, setShow] = useState(() => isIos() && !installed() && !localStorage.getItem(key));
  if (!show) return null;
  const t = TXT[lang] || TXT.en;
  const close = () => { localStorage.setItem(key, "1"); setShow(false); };
  return createPortal(
    <div className="fixed inset-x-3 bottom-3 z-[60] rounded-2xl border bg-card p-4 shadow-2xl animate-in slide-in-from-bottom-4 fade-in duration-500" data-testid="ios-install-tip">
      <button className="absolute right-3 top-3 text-muted-foreground" aria-label="Close" data-testid="ios-install-tip-close" onClick={close}><X className="h-4 w-4" /></button>
      <p className="font-semibold pr-6">{t.title.replace("{name}", name || "")}</p>
      <p className="text-sm text-muted-foreground mt-1">{t.sub}</p>
      <ol className="mt-3 space-y-2 text-sm">
        <li className="flex items-center gap-2"><span className="grid h-7 w-7 place-items-center rounded-full bg-primary/10 text-primary"><Share className="h-4 w-4" /></span>1. {t.s1}</li>
        <li className="flex items-center gap-2"><span className="grid h-7 w-7 place-items-center rounded-full bg-primary/10 text-primary"><SquarePlus className="h-4 w-4" /></span>2. {t.s2}</li>
      </ol>
      <Button size="sm" className="mt-3 w-full rounded-full" data-testid="ios-install-tip-ok" onClick={close}>{t.ok}</Button>
    </div>,
    document.body
  );
}
